import React, { useEffect, useState } from "react";
import "../Groups/GroupsDetail_two.css";
import DashboardHeader from "../../../Components/header/DashboardHeader";
import { IoArrowBackOutline } from "react-icons/io5";
import { Link, useParams } from "react-router-dom";
import { Accordion, Dropdown } from "react-bootstrap";
import { PiShareFatThin } from "react-icons/pi";
import { FaRegCommentDots } from "react-icons/fa";
import { HiDotsVertical } from "react-icons/hi";
import { RiShareForwardLine } from "react-icons/ri";
import { BiLike } from "react-icons/bi";
import { groupDetailApi } from "../../../services/groups";
import { toastMessage } from "../../../utils/toastMessage";
import { handleCopy } from "../../../utils/copyClipboard";
import { fetchSidebarListApi } from "../../../services/categories";
import ChildGroup from "./sections/ChildGroup";
import {
  avatar,
  feedscardsone,
  lock_icon,
  subscription_icon,
} from "../../../assets";
import Feeds from "../Groups/groupDetailSubModules/Feeds";
import { useSelector } from "react-redux";
import { categoryDetailsLink } from "../../../utils/shareLink";
const CategoryDetails = () => {
  const { groupId: id } = useParams(); // Changing Name from groupId to id;
  const [groupId, setGroupId] = useState(id);
  const [groupDetail, setGroupDetail] = useState({});
  const [sidebarList, setSidebarList] = useState([]);
  const { showAuth } = useSelector((state) => state?.showAuth);
  // console.log('groupDetail', groupDetail?._id)
  //--------------Group-Detail----------------
  const getGroupDetail = async () => {
    try {
      const { data } = await groupDetailApi({ _id: groupId });
      const { success, message, data: response } = data;

      if (success) {
        setGroupDetail(response);
        // console.log(response, "Get Parents Ids");
      } else {
        toastMessage(message, "error", "getGroupDetail");
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };
  useEffect(() => {
    getGroupDetail();
  }, []);
  //--------------Group-Detail----------------
  const getSideBarList = async () => {
    try {
      const { data } = await fetchSidebarListApi({ _id: groupId });
      const { success, message, data: response } = data;
      // console.log('response', response)
      if (success) {
        setSidebarList(response);
      } else {
        toastMessage(message, "error", "getGroupDetail");
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };
  useEffect(() => {
    getSideBarList();
  }, []);
  return (
    <>
      <DashboardHeader title={"Groups"} />
      <div className="GroupsDetail_two_parent ">
        <div className="GroupsDetail_two_header">
          <div className="GroupsDetail_two_header_left">
            <Link to={-1}>
              <IoArrowBackOutline className="backarrow_grp_detail" />
            </Link>

            <p>{groupDetail?.name || "---"}</p>
          </div>

          <div className="GroupsDetail_two_header_right">
            <span className="sporttitle">
              {groupDetail?.categoryName || "---"}
            </span>

            <div className="GroupsDetail_two_header_icons">
              {groupDetail?.type === "SUBSCRIPTION" && (
                <button type="button" className="share_icon">
                  <img src={subscription_icon} alt="" />
                </button>
              )}

              {groupDetail?.type === "PRIVATE" && (
                <img src={lock_icon} className="lockicon" />
              )}
              <button onClick={() => handleCopy(`${categoryDetailsLink}${groupDetail?._id}`)}>
                <span className="sharebtn">
                  <PiShareFatThin />
                  Share
                </span>
              </button>
            </div>

            {/* <div className="dropdown">
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <BsThreeDots />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                  <Dropdown.Item href="#/action-2">
                    Another action
                  </Dropdown.Item>
                  <Dropdown.Item href="#/action-3">
                    Something else
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div> */}
          </div>
        </div>

        {/* -------------recursion------------------------- */}

        <div className="GroupsDetail_two_body">
          {/* <RecursionData data={accordionData} /> */}

          <div className="GroupsDetail_two_sidebar ">
            <Accordion key={groupId}>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  {groupDetail?.name || "---"}
                </Accordion.Header>

                <div className="tags_wrapss">
                  <span
                    className="sporttitle"
                  // onClick={() => handleCurrentId(groupDetail?._id)}
                  >
                    {groupDetail?.categoryName || "---"}
                  </span>
                </div>

                {/* /-----------sidebar-list--------------- */}
                {sidebarList &&
                  sidebarList.length > 0 &&
                  sidebarList.map((data, ind) => {
                    return (
                      <Accordion.Body key={ind}>
                        <ChildGroup {...{ data, ind, setGroupDetail }} />
                      </Accordion.Body>
                    );
                  })}
              </Accordion.Item>
            </Accordion>
          </div>
          {/* -------------group-image-and-details---------------------- */}
          <div className="GroupsDetail_two_rightsde">
            <img src={groupDetail?.coverImage || avatar} />
            {/* -----------impotent---------- */}
            {/* <div className="GroupsDetail_two_icon">
              <FaRegHeart className="right_heart" />
              <FaHeart />
            </div> */}

            <p className="para_rightsde">{groupDetail?.description || "N/A"}</p>

            {/* -----------Feed-section------------ */}
            <div className="feeds_text">
              <h4>Feeds</h4>
            </div>
            <Feeds
              groupId={groupDetail?._id ? groupDetail?._id : groupId}
              groupDetail={groupDetail}
              showAuth={showAuth}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryDetails;
